import { List, Record } from 'immutable';

export const TeamMembersList = new Record({
  id: null,
  isNew: true,
  isPending: false,
  currentPage: 1,
  lastPage: 1,
  totalItems: 0,
  itemsId: new List(),
  error: null,
  created_at: new Date(),
  update_at: new Date(),
});
